export default {
  default: () => import("/home/vsts/work/1/s/packages/sa-help/layouts/default.vue"),
  disaster: () => import("/home/vsts/work/1/s/packages/sa-help/layouts/disaster.vue"),
  volunteer: () => import("/home/vsts/work/1/s/packages/sa-help/layouts/volunteer.vue")
}